import React, { useState } from "react";
import AsteronPrezzyCardSpecialOfferModal from "../../../../Modals/SpecialOffersModals/AsteronPrezzyCardSpecialOfferModal/AsteronPrezzyCardSpecialOfferModal";

const AsteronPrezzyCardSpecialOffer: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <React.Fragment>
            <AsteronPrezzyCardSpecialOfferModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
            />
            <a onClick={() => setIsOpen(true)}>
                $50 Prezzy card for every $500 of premium!
            </a>
        </React.Fragment>
    );
};

export default AsteronPrezzyCardSpecialOffer;
